// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-split-pane {
  --border: none;
}

@media only screen and (min-width: 460px) and (max-width: 1140px) {
  .emptyFooter {
    width: 100%;
    height: 56px;
    background-color: var(--planeed-color-white);
    position: absolute;
    bottom: 0;
  }
}

.hide-side-content {
  display: none;
}

.fabButton-discover-more-home {
  width: 150px;
  height: 35px;
  line-height: 40px;
  position: fixed;
  bottom: 50px;
  left: 35px;
  --background: #FFFFFF;
  --border-radius: 50px;
  --border-width: 2px;
  --border-style: solid;
  --border-color: var(--ion-color-secondary);
  --ripple-color: #FFFFFF;
  --background-activated: #FFFF;
  --box-shadow: none;
}
@media only screen and (max-width: 1140px) {
  .fabButton-discover-more-home {
    display: none;
  }
}

.custom-split-pane {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
}

/* Map content fills available space */
.impact-map {
  flex: 1 1 auto;
  transition: margin-right 0.35s ease;
}

/* Tabs container (right side) */
.tabs-container {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: var(--tabs-width, 460px);
  max-width: 100%;
  background: var(--ion-background-color, #fff);
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  transform: translateX(100%);
  transition: transform 0.35s ease;
  display: flex;
  flex-direction: column;
  /* Responsive widths */
}
@media (max-width: 460px) {
  .tabs-container {
    --tabs-width: 100%;
  }
}
@media (min-width: 460px) and (max-width: 1450px) {
  .tabs-container {
    --tabs-width: 460px;
  }
}
@media (min-width: 1450px) and (max-width: 2560px) {
  .tabs-container {
    --tabs-width: 620px;
  }
}
@media (min-width: 2560px) {
  .tabs-container {
    --tabs-width: 740px;
  }
}

/* Open state: slide in */
.tabs-container.open {
  transform: translateX(0);
}

/* Optional: push content when tabs are open */
.tabs-container.open ~ .impact-map {
  margin-right: var(--tabs-width);
}

/* Toggle button */
.toggle-tabs-btn {
  position: absolute;
  top: calc(50vh - 20px);
  right: 0;
  z-index: 20;
  width: 20px;
  height: 60px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  background: var(--planeed-color-white);
  color: var(--ion-color-text-color);
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.35s ease;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
}
@media (min-width: 460px) and (max-width: 1450px) {
  .toggle-tabs-btn {
    right: 460px;
  }
}
@media (min-width: 1450px) and (max-width: 2560px) {
  .toggle-tabs-btn {
    right: 620px;
  }
}
@media (min-width: 2560px) {
  .toggle-tabs-btn {
    right: 740px;
  }
}
.toggle-tabs-btn ion-icon {
  font-size: 20px;
}

/* Adjust button when panel closed */
.tabs-container:not(.open) ~ .toggle-tabs-btn {
  right: 0;
}

.menuOverMap {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  left: 25px;
  border-radius: 60px;
  top: calc(50vh - 175px);
  width: 70px;
  height: 370px;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(3px);
  padding: 10px;
}
.menuOverMap .menu-item {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.25s ease;
}
.menuOverMap .menu-item:hover {
  background-color: var(--planeed-color-white);
}
.menuOverMap .menu-item-large ion-icon {
  transform: scale(1.2);
  transition: transform 0.25s ease;
}
.menuOverMap .menu-item:hover .footer_icon {
  fill: var(--ion-color-warning);
}
.menuOverMap .footer_icon {
  height: 25px;
  width: 25px;
  font-size: 25px;
  fill: #00373d;
}
.menuOverMap .menu-item-active {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--ion-color-secondary);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}
.menuOverMap .footer-icon-active {
  height: 25px;
  width: 25px;
  font-size: 25px;
}

.top-menu-map {
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  background-color: transparent;
  width: 150px;
  right: 30px;
  top: 30px;
  transition: 0.35s ease;
}
.top-menu-map ion-icon {
  font-size: 20px;
  fill: #00373d;
  cursor: pointer;
  transition: 0.35s ease;
}
.top-menu-map .active {
  fill: var(--ion-color-warning);
}
.top-menu-map ion-icon:hover {
  font-size: 20px;
  fill: var(--ion-color-warning);
}

@media (min-width: 460px) and (max-width: 1450px) {
  .top-menu-map-isOpen {
    right: 490px;
  }
}
@media (min-width: 1450px) and (max-width: 2560px) {
  .top-menu-map-isOpen {
    right: 650px;
  }
}
@media (min-width: 2560px) {
  .top-menu-map-isOpen {
    right: 770px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
